import * as withClientParentActions from '../actions/client-parents';
import { ClientParent } from '../models/client-parent';
import { createSelector, createFeatureSelector } from '@ngrx/store';

export interface State {
  clientParents: ClientParent[];
  loading: boolean;
  error: string;
}

export const INITIAL_STATE: State = {
  clientParents: [],
  loading: false,
  error: ''
}

export function reducer(state: State = INITIAL_STATE, action: withClientParentActions.Actions) {
  var errorMessage: string;

  switch (action.type) {
    case withClientParentActions.LOAD:
      {
        return {
          ...state,
          error: '',
          loading: true
        };
      }
    case withClientParentActions.LOAD_COMPLETE:
      {
        return {
          ...state,
          error: '',
          loading: false,
          clientParents: action.payload
        };
      }
    case withClientParentActions.LOAD_ERROR:
      {
        errorMessage = '';
        if (action.payload.hasOwnProperty('message')) {
          errorMessage = action.payload.message;
        }

        return {
          ...state,
          error: errorMessage,
          loading: false,
          clientParents: []
        };

      }
    default:
      {
        return state;
      }
  }
}
